<div class="row">
  <div class="col-md-3 col-sm-4 col-12">
    <select #monthDropDown name="month" id="monthDropDown" class="form-control" [ngModel]="SelectedMonth" (ngModelChange)="setMonth($event)"
      [disabled]="disabled">
      @for (m of Months; track m) {
        <option [value]="m.id">{{m.name}}</option>
      }
    </select>
  </div>
  <div class="col-md-3 col-sm-4 col-12">
    <select #dayDropDown name="dayDropDown" id="dayDropDown" class="form-control" [ngModel]="SelectedDay" (ngModelChange)="setDay($event)"
      [disabled]="disabled">
      @for (d of Days; track d) {
        <option [value]="d">{{d}}</option>
      }
    </select>
  </div>
  <div class="col-md-3 col-sm-4 col-12">
    <select #yearDropDown name="yearDropDown" id="yearDropDown" class="form-control" [ngModel]="SelectedYear" (ngModelChange)="setYear($event)"
      [disabled]="disabled">
      @for (y of Years; track y) {
        <option [value]="y">{{y}}</option>
      }
    </select>
  </div>
  @if (!valid && SelectedYear !== undefined && SelectedMonth !== undefined  && SelectedDay !== undefined ) {
    <div>
      <div class="alert alert-error">Invalid date</div>
    </div>
  }
</div>